export enum DividerOrientation {
  Left = 'left',
  Center = 'center',
  Right = 'right'
}
